<template>
    <div class="bd-sidebar col-md-3 col-xl-2 col-12 card">
        <b-list-group :key="item.name" v-for="item in items">
            <b-list-group-item variant="primary">{{
                item.name
            }}</b-list-group-item>
            <b-list-group-item
                :key="submenu.title"
                :to="submenu.to"
                v-for="submenu in item.children"
            >
                {{ submenu.title }}
                <chevron-right-icon />
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
import ChevronRightIcon from "vue-material-design-icons/ChevronRight";

export default {
    name: "OSideBar",
    components: { ChevronRightIcon },
    props: {
        items: { type: Array, default: () => [] },
    },
};
</script>

<style scoped>
.bd-sidebar {
    height: 100%; /* 100% Full-height */
    position: fixed; /* Stay in place */
    z-index: 100; /* Stay on top */
    top: 0;
    left: 0;
    background-color: whitesmoke;
    overflow-x: hidden; /* Disable horizontal scroll */
    padding-top: 60px; /* Place content 60px from the top */
    transition: 0.5s; /* 0.5 second transition effect to slide in the sidebar */
}
</style>
